export const PLAYER_MODE_ANIMIX = 'animix';
export const PLAYER_MODE_ANIMIX_KODIK = 'animix-kodik';
export const PLAYER_MODE_KODIK = 'kodik';
export const PLAYER_MODE_STORAGE_KEY = 'preferredPlayerMode';

const PLAYER_MODES = new Set([
    PLAYER_MODE_ANIMIX,
    PLAYER_MODE_ANIMIX_KODIK,
    PLAYER_MODE_KODIK,
]);

const KODIK_SOURCE_KEYS = [
    'playerUrl',
    'kodikRaw',
    'kodikRAW',
    'kodikIframe',
    'kodikPlayer',
    'kodikPlayerUrl',
    'kodikUrl',
    'kodikURL',
    'kodikLink',
    'kodik',
    'raw'
];

export const normalizeKodikSrc = (value) => {
    if (!value || typeof value !== 'string') return null;

    const trimmed = value.trim();
    const iframeSrcMatch = trimmed.match(/<iframe[^>]*\ssrc=["']([^"']+)["']/i);
    const src = iframeSrcMatch ? iframeSrcMatch[1] : trimmed;

    if (!src) return null;
    const normalizedSrc = src.startsWith('//') ? `https:${src}` : src;
    try {
        const url = new URL(normalizedSrc);
        return url.protocol === 'https:' ? url.toString() : null;
    } catch (error) {
        return null;
    }
};

export const getKodikSrcFromEntity = (entity) => {
    if (!entity || typeof entity !== 'object') return null;

    for (const key of KODIK_SOURCE_KEYS) {
        const source = normalizeKodikSrc(entity[key]);
        if (source) return source;
    }

    return null;
};

export const getKodikSrc = (...entities) => {
    for (const entity of entities) {
        const source = getKodikSrcFromEntity(entity);
        if (source) return source;
    }

    return null;
};

export const getPreferredPlayerMode = () => {
    try {
        const mode = localStorage.getItem(PLAYER_MODE_STORAGE_KEY);
        return PLAYER_MODES.has(mode) ? mode : PLAYER_MODE_ANIMIX;
    } catch (error) {
        return PLAYER_MODE_ANIMIX;
    }
};

export const savePreferredPlayerMode = (mode) => {
    if (!PLAYER_MODES.has(mode)) return;
    try {
        localStorage.setItem(PLAYER_MODE_STORAGE_KEY, mode);
    } catch (error) {
        // Playback still works when storage is unavailable.
    }
};

export const resolvePlayerMode = (series, preferredMode) => {
    const preferred = PLAYER_MODES.has(preferredMode) ? preferredMode : PLAYER_MODE_ANIMIX;
    const hasAnimix = Boolean(series && !series.kodikOnly);
    const hasKodik = Boolean(series?.hasKodik || getKodikSrc(series));

    if (preferred === PLAYER_MODE_ANIMIX && hasAnimix) return PLAYER_MODE_ANIMIX;
    if (preferred !== PLAYER_MODE_ANIMIX && hasKodik) return preferred;
    if (hasAnimix) return PLAYER_MODE_ANIMIX;
    if (hasKodik) return PLAYER_MODE_KODIK;
    return PLAYER_MODE_ANIMIX;
};
